enum PickingJourneySearchTypes {
    Folio = 'folio',
    Lpn = 'lpn',
    Sku = 'sku'
}

export default PickingJourneySearchTypes;
